import AppContext from "AppContext";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

let controlador = null

export function mostrarSelecionarContrato() {
  controlador && controlador.mostrar()
}

export function ocultarSelecionarContrato() {
  controlador && controlador.ocultar()
}

export default function SelecionarContrato() {
  const [isOpen, setIsOpen] = useState(false)
  const { state, actions } = useContext(AppContext)
  const navigate = useNavigate()

  useEffect(() => {

    controlador = {
      mostrar: () => setIsOpen(true),
      ocultar: () => setIsOpen(false)
    }

    return () => controlador = null // evitar fuga de memória se o objeto for destruido
  }, [])

  const handleSelecionarContrato = (contrato) => {
    actions.setContrato(contrato)
    setIsOpen(false)
    navigate('/admin')
  }

  return (
    <Modal isOpen={isOpen}>
      <ModalBody>
        <h2>Contratos</h2>
        {(state?.user?.contratos || []).map(contrato => (
          <div
            className="rounded border px-2 py-1 mb-1 shadow"
            key={contrato.id}
            style={{ cursor: 'pointer' }}
            onClick={() => handleSelecionarContrato(contrato)}
          >
            {contrato.numero}
          </div>
        ))}
      </ModalBody>
    </Modal>
  )
}